import { render, staticRenderFns } from "./GeradorWhatsAppLink.vue?vue&type=template&id=5ba79d72&"
import script from "./GeradorWhatsAppLink.vue?vue&type=script&lang=js&"
export * from "./GeradorWhatsAppLink.vue?vue&type=script&lang=js&"
import style0 from "./GeradorWhatsAppLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports